import Vue from 'vue';
import Vuex from 'vuex';

import application from './application';
import category from './category';
import delivery from './delivery';
import location from './location';
import payment from './payment';
import product from './product';
import order from './order';
import user from './user';

Vue.use(Vuex);

/*
 * If not building with SSR mode, you can
 * directly export the Store instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Store instance.
 */

export default function (/* { ssrContext } */) {
  return new Vuex.Store({
    modules: {
      application,
      category,
      delivery,
      location,
      payment,
      product,
      order,
      user,
    },

    // enable strict mode (adds overhead!)
    // for dev mode only
    strict: process.env.DEV,
  });
}
